import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {LocalStorageUtils, TOKEN_KEY,USER_ID} from "../../@admin/utils/methods/local-storage.utils";
import {MsalService} from "@azure/msal-angular";
import { ProfileDetails } from '../../api/models';

@Injectable({providedIn: 'root'})
export class AuthService {
  public _profileDetails: BehaviorSubject<ProfileDetails | null> = new BehaviorSubject<ProfileDetails | null>({});
  private authService: MsalService = inject(MsalService);

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  get accessToken(): string {
    return localStorage.getItem('accessToken') ?? '';
  }

  /**
   * Setter & getter for access token
   */
  set accessToken(token: string) {
    LocalStorageUtils.setAccessToken(TOKEN_KEY, token);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------


  /**
   * Sign out
   */
  signOut(): void {
    LocalStorageUtils.removeInfo(USER_ID);
    this.authService.logoutRedirect();
  }

  clearStorageNavigateSignIn(): void {
    window.localStorage.clear();
    // Reload the app
    location.reload();
  }


  /**
   * Check the authentication status
   */
  check(): Observable<boolean> {
    return of(this.authService.instance.getAllAccounts().length > 0);
  }
}
